import { render, staticRenderFns } from "./style2.vue?vue&type=template&id=1b333484&scoped=true&"
import script from "./style2.vue?vue&type=script&lang=js&"
export * from "./style2.vue?vue&type=script&lang=js&"
import style0 from "./style2.vue?vue&type=style&index=0&id=1b333484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b333484",
  null
  
)

export default component.exports